export const IDENTT = 'identt';

export const HAVE_COPY_ID_FAX_KEY = 145;
export const DOCUMENT_UPLOAD_REQUEST_SERVICE = 'identt';
export const DOCUMENT_UPLOAD_REQUEST_PROFILE = 'portal';

export const HAVE_COPY_ID_FAX_VALUE = {
    VERIFIED: '1'
};

export const VERIFICATION_STATUS = {
    VERIFIED: 'verified'
};

export const VERIFIED_STATUS = {
    value: VERIFICATION_STATUS.VERIFIED,
    showVerifyButton: false
};

export const OPEN_IN = {
    IFRAME: 'iframe',
    NEW_TAB: 'newTab',
    NEW_WINDOW: 'newWindow'
};
